import type { SelectOption } from '../../../types'

export function filterSelectOptions(
  options: readonly SelectOption[],
  query: string
): readonly SelectOption[] {
  const normalizedQuery = query.trim().toLowerCase()
  if (!normalizedQuery) {
    return options
  }
  return options.filter((option) =>
    option.label.toLowerCase().includes(normalizedQuery)
  )
}
